import { MATERIAL_DEFAULTS } from './constants';

export function newBooth() {
  return {
    id: Date.now() + Math.random(),
    buildYear: '',
    type: '',
    separatelyHeated: '',
    burnerEnergy: '',
    energyConsumption: '',
    energyConsumptionUnit: 'kwh',
    efficiencyTech: [],
    dryingType: '',
    dryingTemp: '',
    dryingTime: '',
    cyclesPerDay: '',
    idleRuns: '',
    photoFileName: '',
  };
}

export function newHeatingSystem() {
  return {
    id: Date.now() + Math.random(),
    type: '',
    unit: 'kwh',
    value: '',
  };
}




export function getInitialFormData() {
  return {
    isChanged: false,
    reportingYear: new Date().getFullYear(),

    // Step 1 – Operation
    activitySpenglerarbeiten: 50,
    activityLackierarbeiten: 35,
    activityWeitere: 15,

    garageType: '',
    garageBrands: '',

    buildingRelationship: '',

    hasMechanicalWorkshop: false,
    hasVehicleSales: false,
    hasWashingSystem: false,
    hasFuelStation: false,
    hasPublicChargingStations: false,
    publicChargingPointsCount: '',

    productiveFte: '',
    totalAreaM2: '',
    productiveAreaM2: '',

    soldHoursTotal: '',
    splitSoldHours: false,
    soldHoursPaint: '',
    soldHoursBody: '',

    annualRevenue: '',
    splitRevenue: false,
    revenuePaint: '',
    revenueBody: '',

    averageHourlyRate: '',
    splitHourlyRate: false,
    hourlyRatePaint: '',
    hourlyRateBody: '',

    // Step 2 – Data Sources
    gcsRequested: false,
    silverdatRequested: false,

    carbonPulseFileName: '',
    carbonPulseImportMessage: '',
    carbonPulseImportError: '',
    carbonPulseImportSuccessful: false,
    carbonPulseAvailableYears: [],
    carbonPulseSelectedYear: '',
    carbonPulseJahreswerte: null,
    carbonPulseGebaeudeM2: null,
    carbonPulseImportedFields: [],

    // Step 3 – Energy & Heating
    electricityMix: '',
    electricityValue: '',
    electricityUnit: 'kwh',
    electricityInvoiceFiles: [],
    electricityInvoicePeriodStart: '',
    electricityInvoicePeriodEnd: '',
    electricityInvoiceImportMessage: '',
    electricityInvoiceImportError: '',

    pvStatus: '',
    pvProductionKwh: '',
    pvFeedInKwh: '',

    heatingSystems: [newHeatingSystem()],
    heatingUploadFileName: '',

    gasShutdownPlanned: false,
    gasShutdownYear: '',

    oilHeatingReplacementPlanned: false,
    oilHeatingReplacementYear: '',


    // Step 4 – Paint & Repair
    paintBooths: [newBooth()],

    paintLiters: '',
    airDryingPaintShare: 0,

    materials: { ...MATERIAL_DEFAULTS['Mischbetrieb'] },

    repairsPerYear: '',
    repairTypes: [],
    repairTypeShares: {},

    sparePartsTendency: '',
    recyclingPartsShare: 10,
    sparePartsValueCHF: '',

    // Step 5 – Other
    fleetFileName: '',
    fleetImportMessage: '',
    fleetImportError: '',
    fleetImportedVehicles: [],
    fleetImportSuccessful: false,
    combustionCount: '',
    combustionAvgAge: '',
    combustionAvgKm: '',
    electricCount: '',
    electricAvgAge: '',
    electricAvgKm: '',
    hybridCount: '',
    hybridAvgAge: '',
    hybridAvgKm: '',
    fleetOwnership: '',

    wasteCategories: [],
    bodyPartsThirdPartyShare: 0,

    hasCompressedAir: false,
    compressorType: '',
    compressorBuildYear: '',
    compressedAirPressureBar: '',
    compressorHeatRecovery: '',
    compressedAirLeaks: '',
    pneumaticGrinders: '',
    lighting: '',
  };
}
